import { render } from "./CartDiscountsWidget.vue?vue&type=template&id=514a3dc0&scoped=true"
import script from "./CartDiscountsWidget.vue?vue&type=script&lang=ts"
export * from "./CartDiscountsWidget.vue?vue&type=script&lang=ts"

import "./CartDiscountsWidget.vue?vue&type=style&index=0&id=514a3dc0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-514a3dc0"

export default script